import {
  Autocomplete,
  Box,
  Button,
  Divider,
  FieldError,
  Flexbox,
  Heading,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Select,
  shootToast,
  Stack,
  StackRow,
} from "codekit";
import { convertCurrencyNumber } from "../utils/function";
import { useEffect, useState } from "react";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import { useGetAutoClientMutation } from "../../../../libs/redux/slices/Modimpxx/Anticipo/anticipoApiSlice";
import {
  useGetTotalAdvanceMutation,
  useLazyGetDoGlobalByClientQuery,
} from "../../../../libs/redux/slices/Financix/Dosptefa/dosptefaApiSlice";
import { useGetAutocompleteWithParamsMutation } from "../../../../libs/redux/slices/autocompSlice/autocompApiSlice";
import { useSaveTaskGeneralMutation } from "../../../../libs/redux/slices/Ordtraxx/Tareasxx/TareasxxApiSlice";

/**
 * Componente para la generacion de la tarea de traslado de anticipo global
 */
const Trasladv = ({ setTraslant }) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({ mode: "onBlur", defaultValues: { OPERATIONS: [{ DOCNROXX: "", VALORXXX: 0 }] } });
  const [quota, setQuota] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [missingValue, setMissingValue] = useState(0);
  const [results, setResults] = useState([]);
  const [getAutoClient] = useGetAutoClientMutation();
  const [operationsClient, setOperationsClient] = useState([]);
  const [getDoGlobalByClient] = useLazyGetDoGlobalByClientQuery();
  const [getAutocompleteWithParams] = useGetAutocompleteWithParamsMutation();
  const [resultsDo, setResultsDo] = useState([]);
  const [getTotalAdvance] = useGetTotalAdvanceMutation();
  const [saveTaskGeneral, { isLoading }] = useSaveTaskGeneralMutation();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "OPERATIONS",
  });

  //Funcion para el autocompletar de cliente
  const handleSearch = async (value, cb) => {
    return await getAutoClient({
      filter: value,
    })
      .unwrap()
      .then((response) => {
        setResults(response.data);
      })
      .catch((err) => {
        console.log("entro en el catch", err);
      })
      .finally(() => {
        cb();
      });
  };

  //Funcion para consultar los DO globales de un cliente
  const handleGetDosClient = async (value) => {
    await getDoGlobalByClient({ filters: { CLIIDXXX: value } })
      .unwrap()
      .then((response) => {
        const { data } = response;
        let options = [{ text: "SELECCIONE", value: "" }];
        if (data.length > 0) {
          options = [...options, ...data.map((item) => ({ text: item.DOCNROXX, value: item.DOCNROXX }))];
          if (data.length === 1) {
            setValue("DOCNROXX", data[0].DOCNROXX);
            handleTotalAdvance(data[0].DOCNROXX);
          }
        }
        setOperationsClient(options);
      })
      .catch();
  };

  const CLIIDXXX = useWatch({ control, name: "CLIIDXXX", defaultValue: "" });
  const OPERATIONS = useWatch({ control, name: "OPERATIONS" });

  //Consultar el total anticipo de una operacion
  const handleTotalAdvance = async (value) => {
    if (value === "") {
      setQuota(0);
      return;
    }
    await getTotalAdvance({ filters: { CLIIDXXX: CLIIDXXX.split(" - ")[0], DOCNROXX: value } })
      .unwrap()
      .then((response) => {
        const { data = 0 } = response;
        setQuota(data);
      })
      .catch();
  };

  //consulta del autocompletar
  const operations = async (value, cb, endpoint) => {
    if (CLIIDXXX !== "") {
      let filter = [];
      let cliId = CLIIDXXX.split(" - ")[0];
      filter["CLIIDXXX"] = cliId;
      filter["DOCNROXX"] = value;
      return await getAutocompleteWithParams({
        filter: filter,
        endpoint,
        MODURLXX: "Modimpxx",
        PRODURLX: "Anticipo",
      })
        .unwrap()
        .then((response) => {
          const currentDos = OPERATIONS.map((element)=> element.DOCNROXX)
          const options = response.data.filter((item) => !currentDos.includes(item.id.toString()))
          setResultsDo(options);
        })
        .catch((err) => {
          console.log("entro en el catch", err);
        })
        .finally(() => {
          cb();
        });
    } else {
      shootToast({
        text: "Debe seleccionar un Importador",
        variant: "error",
        autoHide: true,
        duration: 2000,
      });
      cb();
    }
  };

  //Calcular valor a pagar
  useEffect(() => {
    let total = 0;
    OPERATIONS.forEach((element) => {
      total += parseFloat(element.VALORXXX);
    });
    setTotalPayment(total);
    setMissingValue(total - quota);
  }, [OPERATIONS, quota]);

  //Funcion para la creacion de la tarea
  const handleCreateTask = async (formData) => {
    const dataFilter = formData.OPERATIONS.filter((item) => item.VALORXXX !== 0);
    if (dataFilter.length === 0) {
      shootToast({
        variant: "error",
        text: "Debe ingresar al menos un valor",
        autoHide: true,
      });
      return;
    }
    const dataJson = dataFilter.map((item) => ({ DOCNROXX: item.DOCNROXX, VALORXXX: item.VALORXXX }));
    const dataSolved = {
      CLIIDXXX: CLIIDXXX.split(" - ")[0],
      MODIDXXX: 109,
      PROIDXXX: 103,
      CLATARID: 167,
      TOKIDXXX: 100,
      TARDICXX: { JSONOPER: dataJson, VLRTOANT: totalPayment, DOGLOBAL: formData.DOCNROXX },
      ESTAIDXX: 100,
      ESTGESID: 100,
    };
    await saveTaskGeneral(dataSolved)
      .unwrap()
      .then(() => {
        setTraslant(false);
      })
      .catch();
  };

  return (
    <Modal size="xl" isOpen={true}>
      <ModalHeader>
        <Flexbox justifyContent="between" alignItems="center">
          <Heading variant="heading-6" color="accent-600">
            Traslado Anticipo Global
          </Heading>
          <Button
            variant="secondary"
            icon="close"
            onlyIcon
            size="m"
            onClick={() => {
              setTraslant(false);
            }}
          />
        </Flexbox>
      </ModalHeader>
      <form onSubmit={handleSubmit(handleCreateTask)}>
        <ModalBody size="xl">
          <Box mb={8}>
            <Stack gap={7} columnsVariant="form-2">
              <StackRow>
                <Label>Cliente</Label>
                <Controller
                  control={control}
                  name={`CLIIDXXX`}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      placeholder="Nit"
                      textLoading="Buscando..."
                      textNoResults="No se encontraron registros"
                      minLengthToSearch={2}
                      selected={value}
                      searchResults={results}
                      onChangeSearch={(value, cb) => handleSearch(value, cb)}
                      onItemClick={(context) => {
                        onChange(`${context.item.label}`);
                        handleGetDosClient(context.item.id);
                      }}
                      onResetSelected={(context) => {
                        onChange("");
                        setOperationsClient([]);
                      }}
                      isInvalid={errors.CLIIDXXX}
                      // readOnly={isCreating || data !== null || isClient}
                    />
                  )}
                />
                {errors.CLIIDXXX && <FieldError>El campo Cliente no puede estar vacío </FieldError>}
              </StackRow>
              <StackRow>
                <Label>DO Global</Label>
                <Controller
                  control={control}
                  name={`DOCNROXX`}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <Select
                      options={operationsClient}
                      value={value}
                      onChangeValue={(context) => {
                        onChange(context.option.value);
                        handleTotalAdvance(context.option.value);
                      }}
                      // readOnly={!isEdit || data.RESOBJXX === "COMPLETADO"}
                      isInvalid={errors.DOCNROXX}
                    />
                  )}
                />
                {errors.DOCNROXX && <FieldError>El campo DO Global no puede estar vacío </FieldError>}
              </StackRow>
            </Stack>
          </Box>
          <Box mb={8}>
            <Divider text="Trasladar A" color="accent-600" />
          </Box>
          <Box bg="neutral-200" borderColor="neutral-300" rounded="md" spacing={3} mt={8} mb={8}>
            <Stack gap={2}>
              <Label>Operaciones</Label>
              {fields.map((item, index) => (
                <Box key={item.id} spacingX={2} spacingTop={2} spacingBottom={4} rounded="md" bg="white">
                  <Stack gap={7} columnsVariant="form-4">
                    <StackRow responsiveColSpan={{ initial: 3 }}>
                      <Stack gap={7} columnsVariant="form-2">
                        <StackRow>
                          <Label>Numero de DO</Label>
                          <Controller
                            control={control}
                            name={`OPERATIONS.${index}.DOCNROXX`}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                placeholder="Buscar"
                                textLoading="Buscando..."
                                textNoResults="No se encontraron registros"
                                minLengthToSearch={2}
                                selected={value}
                                searchResults={resultsDo}
                                onChangeSearch={(value, cb) => operations(value, cb, "getDoByClient")}
                                onItemClick={(context) => {
                                  onChange(`${context.item.label}`);
                                }}
                                onResetSelected={(context) => {
                                  onChange("");
                                }}
                                isInvalid={errors?.OPERATIONS?.[index]?.DOCNROXX}
                                // readOnly={isCreating || data !== null || isClient}
                              />
                            )}
                          />
                          {errors?.OPERATIONS?.[index]?.DOCNROXX && (
                            <FieldError>El campo Numero de DO no puede estar vacío </FieldError>
                          )}
                        </StackRow>
                        <StackRow>
                          <Label>Valor</Label>
                          <Controller
                            name={`OPERATIONS.${index}.VALORXXX`}
                            control={control}
                            rules={{ validate:(value) => value > 0 }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                type="currency"
                                currencyMode="european"
                                iconLeft="Dollar"
                                isInvalid={errors?.OPERATIONS?.[index]?.VALORXXX}
                                // readOnly={!isEdit || data.RESOBJXX === "COMPLETADO"}
                              />
                            )}
                          />
                          {errors?.OPERATIONS?.[index]?.VALORXXX && (
                            <FieldError>El campo Valor no puede estar vacío </FieldError>
                          )}
                        </StackRow>
                      </Stack>
                    </StackRow>
                    <StackRow>
                      <Box spacingY={6}>
                        <Button
                          type="button"
                          onClick={() => remove(index)}
                          variant="error-light"
                          icon="trash"
                          disabled={fields.length === 1}
                          size="m"
                          onlyIcon
                        />
                      </Box>
                    </StackRow>
                  </Stack>
                </Box>
              ))}
              <StackRow>
                <Button
                  type="button"
                  variant="secondary-light"
                  icon="plus"
                  size="l"
                  onClick={() => append({ DOCNROXX: "", VALORXXX: 0 })}
                >
                  Agregar otro
                </Button>
              </StackRow>
            </Stack>
          </Box>
          <Box mb={8}>
            <Stack bg="success-500" spacing={4} rounded="md" gap={7}>
              <Flexbox justifyContent="between" gap={4}>
                <Flexbox justifyContent="start">
                  <Label color="white">Total</Label>
                </Flexbox>
                <Flexbox justifyContent="end">
                  <Label color="white">$ {convertCurrencyNumber(totalPayment)}</Label>
                </Flexbox>
              </Flexbox>
            </Stack>
          </Box>
          <Box mb={8}>
            <Box
              mb={5}
              pb={0}
              pt={0}
              bg={missingValue > 0 || quota === 0 ? "error-600" : "success-600"}
              rounded="md"
              spacing={3}
            >
              <Stack gap={4} columnsVariant="form-2">
                <StackRow>
                  <Box mb={5}>
                    <Label
                      color="white"
                      icon={missingValue > 0 || quota === 0 ? "triangle-exclamation" : "circle-check"}
                    >
                      {missingValue > 0 || quota === 0
                        ? "EL DO GLOBAL NO CUENTA CON SALDO DISPONIBLE"
                        : "EL DO GLOBAL CUENTA CON SALDO DISPONIBLE"}
                    </Label>
                  </Box>
                </StackRow>
              </Stack>
              <Stack gap={4} columnsVariant="form-3">
                <StackRow>
                  <Box
                    mb={5}
                    pb={0}
                    pt={0}
                    bg={missingValue > 0 || quota === 0 ? "error-400" : "success-400"}
                    rounded="md"
                    spacing={3}
                  >
                    <Stack gap={7}>
                      <StackRow>
                        <Label p={1} weight="medium" color="white" style={{ position: "absolute", float: "left" }}>
                          Cupo disponible
                        </Label>
                        <Label alignment="left" color="white" style={{ position: "absolute", float: "right" }}>
                          $ {convertCurrencyNumber(quota)}
                        </Label>
                      </StackRow>
                    </Stack>
                  </Box>
                </StackRow>
                <StackRow>
                  <Box
                    mb={5}
                    pb={0}
                    pt={0}
                    bg={missingValue > 0 || quota === 0 ? "error-400" : "success-400"}
                    rounded="md"
                    spacing={3}
                  >
                    <Stack gap={7}>
                      <StackRow>
                        <Label p={1} weight="medium" color="white" style={{ position: "absolute", float: "left" }}>
                          Valor transaccional
                        </Label>
                        <Label alignment="left" color="white" style={{ position: "absolute", float: "right" }}>
                          $ {convertCurrencyNumber(totalPayment)}
                        </Label>
                      </StackRow>
                    </Stack>
                  </Box>
                </StackRow>
                <StackRow>
                  <Box
                    mb={5}
                    pb={0}
                    pt={0}
                    bg={missingValue > 0 || quota === 0 ? "error-400" : "success-400"}
                    rounded="md"
                    spacing={3}
                  >
                    <Stack gap={7}>
                      <StackRow>
                        <Label p={1} weight="medium" color="white" style={{ position: "absolute", float: "left" }}>
                          Valor faltante
                        </Label>
                        <Label alignment="left" color="white" style={{ position: "absolute", float: "right" }}>
                          $ {missingValue < 0 ? 0 : convertCurrencyNumber(missingValue)}
                        </Label>
                      </StackRow>
                    </Stack>
                  </Box>
                </StackRow>
              </Stack>
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flexbox justifyContent="between" gap={4}>
            <Flexbox justifyContent="start">
              <Button
                type="button"
                variant="secondary"
                size="2l"
                minWidth={200}
                onClick={() => setTraslant(false)}
                inactive={isLoading}
              >
                Cancelar
              </Button>
            </Flexbox>
            <Flexbox justifyContent="end">
              <Button
                type="submit"
                variant="primary-bold"
                size="2l"
                minWidth={180}
                inactive={quota === 0 || missingValue > 0}
                isLoading={isLoading}
              >
                Guardar
              </Button>
            </Flexbox>
          </Flexbox>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default Trasladv;
